import React, { useState, useEffect } from "react";
import Select from "react-select";
// import ImageWithBasePath from "../../img/imagewithbasebath";
// import { Link } from "react-router-dom";
import {
  API_BASE_URL,
  GET_STORE,
  GET_TRANSFER_PROD,
  GET_STOCK_TRANSFER_BY_ID,
  GET_USER_STORES,
  GET_VSTORE_PROD,
  INSERT_TRANSFER_STOCK,
} from "../../../Config";
import Axios from "axios";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
// import UploadFiles from "../../../feature-module/UploadFiles";
// import jsPDF from 'jspdf';
// import html2pdf from 'html2pdf.js';
// import dayjs from 'dayjs';


const StockTransferModal = ({ transferObj }) => {
  const [userDataSession, setUserDataSession] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [offcanvasWidth, setOffcanvasWidth] = useState("53%");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOffcanvasWidth("75%");
      } else {
        setOffcanvasWidth("45%");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [userStoresData, setUserStoresData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transferproductsData, setTransferProductsData] = useState([]);
  const [selectedReceivedDate, setSelectedReceivedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedUserStore, setSelectedUserStore] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productNotes, setProductNotes] = useState("");
  const [trackingDetails, setTrackingDetails] = useState(transferObj?.TrackingDetails);
  const [btnSubLoading, setBtnSubLoading] = useState(false);
  const [transferProductsViewData, setTransferProductsViewData] = useState([]);
  const [addErrorMess, setAddErrorMess] = useState('');
  const [editableTransferDate, setEditableTransferDate] = useState('');
  const [transferProductErro, setTransferProductErro] = useState('');
  const [editableTransferProducts, setEditableTransferProducts] = useState(transferProductsViewData);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setUserStoresData(response.data.ResultData);
            console.log(
              "Data fetched successfully store user data:",
              response.data.Message
            );
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            setStoresData(response.data.ResultData);
            console.log("Data fetched successfully:");
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      // console.log(transferObj, "ttt ttt");
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_STOCK_TRANSFER_BY_ID}?OrgId=${userDataSession.OrgId}&TransactionId=${transferObj.TransferId}`
      )
        .then((response) => {
          if (response.data.Status) {
            console.log(response.data.ResultData)
            setTransferProductsViewData(response.data.ResultData);
            setEditableTransferProducts(response.data.ResultData);
            setLoading(false);
          } else {
            setLoading(false);
            console.error("Error fetching data:", response.data.ResultData);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, transferObj]);

  useEffect(() => {
    if (selectedUserStore && userDataSession.OrgId) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: 0,
        ProductId: 0,
        StoreId: selectedUserStore.value,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };

      console.log(requestData, "data sending to api store main");

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
            console.log(response.data.ResultData, "store products");
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [selectedUserStore, userDataSession]);

  const handleUserStoreChange = (selectedOption) => {
    setSelectedUserStore(selectedOption);
    // console.log(selectedStore, selectedUserStore, selectedProduct);
  };

  // const showUploadFilesModal = (purchaseObj) => {
  //   setUploadStockObj(purchaseObj);
  // };

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date.target.value);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  useEffect(() => {
    if (
      selectedUserStore?.value &&
      selectedStore?.value &&
      selectedProduct?.value
    ) {
      const requestData = {
        StoreId: selectedUserStore.value,
        DestinationStoreId: selectedStore.value,
        ProductId: selectedProduct.value,
      };

      // console.log(requestData, "r r r r r");

      Axios.post(`${API_BASE_URL}${GET_TRANSFER_PROD}`, requestData)
        .then((response) => {
          console.log(response.data, "a a a a a");
          if (response.data.Status) {
            setTransferProductErro('');
            // Add Quantity field and append the new data to the existing data
            const resultDataWithQuantity = response.data.ResultData.map(
              (item) => ({ ...item, Quantity: "" })
            );

            setTransferProductsData((prevData) => {
              // Check if the product is already in the list to avoid duplicates
              const isProductAlreadyAdded = prevData.some(
                (item) => item.Id === selectedProduct.value
              );
              if (!isProductAlreadyAdded) {
                return [...prevData, ...resultDataWithQuantity];
              } else {
                return prevData;
              }
            });
          } else {
            setTransferProductErro('*Product is Not-Available/Inactive in Destination Store..!')
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [selectedProduct, selectedStore, selectedUserStore]);

  const handleDelete = (index) => {
    setTransferProductsData((prevData) =>
      prevData.filter((_, i) => i !== index)
    );
  };

  const handleQuantityChange = (index, newQuantity) => {
    setTransferProductsData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, Quantity: newQuantity } : item
      )
    );
  };

  const handleSubmit = (status, event) => {
    if (event) event.preventDefault();
    setBtnSubLoading(true);

    if(!selectedDate) {
      setAddErrorMess('Please select tranfer date..');
      setBtnSubLoading(false);
      return;
    }

    if (!trackingDetails) { 
      setAddErrorMess('Please enter courier details..');
      setBtnSubLoading(false);
      return;
    }

    const stockTransferData = [
      {
        Id: 0,
        FromStoreId: selectedUserStore.value,
        ToStoreId: selectedStore.value,
        TransferRequestDate: new Date().toISOString().split("T")[0],
        TransferDate: selectedDate,
        Notes: productNotes,
        Status: status,
        TrackingDetails: trackingDetails,
      },
    ];

    console.log(
      transferproductsData,
      "transferproductsData transferproductsData transferproductsData"
    );
    const productDetailsData = transferproductsData.map((item) => ({
      DetailId: 0,
      ProductId: item.Id,
      ReqQuantity: item.Quantity,
      UOM: item.UOM,
      Comments: item.Comments,
      TransferQty: item.Quantity,
      ReturnQty: item.ReturnQty,
    }));

    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      Stocktransfer: stockTransferData,
      productdetails: productDetailsData,
      IndentStatus: "0",
    };
    console.log(payload, "data sending to api for insert data");

    Axios.post(`${API_BASE_URL}${INSERT_TRANSFER_STOCK}`, payload)
      .then((response) => {
        setBtnSubLoading(false);
        console.log(response.data, "response from service..");
        if (response.data[0].Success == 1) {
          setBtnSubLoading(false);
          Swal.fire({
            title: `Stock Transfer added Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setBtnSubLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setBtnSubLoading(false);
        console.error(
          "Error submitting data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const handleReceiveBtnClick = (e) => {
    e.preventDefault();
    setBtnSubLoading(true);

    const stockTransferData = [
      {
        Id: transferObj?.TransferId,
        FromStoreId: transferObj?.FromStoreId,
        ToStoreId: transferObj?.ToStoreId,
        TransferRequestDate: transferObj?.TransferRequestDate,
        TransferDate: formatDate(transferObj?.TransferDate),
        Notes: transferObj?.Notes,
        Status: 'RECEIVED',
        IndentNo: transferObj?.IndentNo,
        IndentStatus: 5,
        ReceivedDate: selectedReceivedDate,
        TrackingDetails: transferObj?.TrackingDetails ? transferObj?.TranckingDetails : "0",
      },
    ];
   
    const productDetailsData = transferProductsViewData.map((item) => ({
      DetailId: item.DetailId,
      ProductId: item.ProductId,
      ReqQuantity: item.ReqQuantity,
      UOM: item.UOM,
      Comments: item.Comments,
      TransferQty: item.TransferQty,
      ReturnQty: item.ReturnQty,
    }));

    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      Stocktransfer: stockTransferData,
      productdetails: productDetailsData,
      IndentStatus: 5,
      IndentNo: transferObj?.IndentNo ? transferObj?.IndentNo : "0"
    };

    console.log(payload, " data sending to api for receive");

    Axios.post(`${API_BASE_URL}${INSERT_TRANSFER_STOCK}`, payload)
      .then((response) => {
        if (response.data[0].Success == 1) {
          setBtnSubLoading(false);
          Swal.fire({
            title: `Transfered Stock Received Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              setBtnSubLoading(false);
              window.location.reload();
            }
          });
        } else {
          setBtnSubLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setBtnSubLoading(false);
        console.error(
          "Error submitting data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  useEffect(() => {
    if (transferObj?.TransferDate) {
      setEditableTransferDate(formatDateForInput(transferObj.TransferDate));
    }
  }, [transferObj]);

  const handleTransferQtyChange = (event, index) => {
    const value = event.target.value;

    // Ensure that the array exists and that you're accessing a valid index
    if (!transferProductsViewData || !transferProductsViewData[index]) {
      console.error("Item does not exist in the array");
      return;
    }

    console.log(transferProductsViewData, 'transferProductsViewData')

    // Create a copy of the current products array
    const updatedProducts = [...transferProductsViewData];

    // Update the specific product's TransferQty
    updatedProducts[index] = {
      ...updatedProducts[index],
      TransferQty: value,
    };

    // Update the state with the new array
    setEditableTransferProducts(updatedProducts);
  };

  const handleEditSubmit = (status, event) => {
    if (event) event.preventDefault();
    setBtnSubLoading(true);

    console.log(editableTransferProducts, 'editableTransferProducts');

    const stockTransferData = [
      {
        Id: transferObj.TransferId, // Use existing Id for editing
        FromStoreId: transferObj?.FromStoreId,
        ToStoreId: transferObj?.ToStoreId,
        TransferRequestDate: transferObj?.TransferRequestDate,
        TransferDate: editableTransferDate ? editableTransferDate : transferObj?.TransferDate,
        Notes: transferObj?.Notes,
        Status: status,
        TrackingDetails: trackingDetails ? trackingDetails : transferObj?.TrackingDetails,
      },
    ];

    const productDetailsData = editableTransferProducts.map((item) => ({
      DetailId: item.DetailId,
      ProductId: item.ProductId,
      ReqQuantity: item.ReqQuantity,
      UOM: item.UOM,
      Comments: item.Comments,
      TransferQty: item.TransferQty,
      ReturnQty: item.ReturnQty ? item.ReturnQty : 0,
    }));

    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      Stocktransfer: stockTransferData,
      productdetails: productDetailsData,
      IndentStatus: "0",
    };

    console.log(payload, 'data sending to api')

    Axios.post(`${API_BASE_URL}${INSERT_TRANSFER_STOCK}`, payload)
      .then((response) => {
        setBtnSubLoading(false);
        if (response.data[0].Success === 1) {
          Swal.fire({
            title: `Stock Transfer updated successfully.`,
            icon: "success",
          }).then(() => window.location.reload());
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to update Stock Transfer.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setBtnSubLoading(false);
        console.error("Error updating data:", error);
      });
  };

  return (
    <div>
      {/* Add Stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddStockTrnsf"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: offcanvasWidth, maxWidth: '53%' }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel">Add Transfer By Product</h4>
          
          <div className="d-flex">
            <button
              type="button"
              className="btn-close text-reset mt-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div>
            <form>
              <div className="row">
                <div className="col-lg-4">
                  <div className="input-blocks">
                    <label>Source Store<span className="fw-bold text-danger">*</span></label>
                    <Select
                      className="select"
                      onChange={handleUserStoreChange}
                      options={userStoresData.map((store) => ({
                        value: store.StoreId,
                        label: store.Name,
                      }))}
                      styles={customStyles}
                      placeholder="Choose from store"
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-blocks">
                    <label>Destination Store<span className="fw-bold text-danger">*</span></label>
                    <Select
                      className="select"
                      id="storeSelect"
                      onChange={handleStoreChange}
                      options={storesData.map((store) => ({
                        value: store.Id,
                        label: store.Name,
                      }))}
                      placeholder="Choose to store"
                      styles={customStyles}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <label className="mb-2">Date<span className="fw-bold text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={handleDateChange}
                    value={selectedDate}
                    required
                  />
                </div>
                <p className="text-danger fw-bold">{addErrorMess}</p>
                <div className="col-lg-12">
                  <div className="input-blocks search-form mb-0">
                    <label>Notes</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter notes"
                      value={productNotes}
                      onChange={(e) => {
                        setProductNotes(e.target.value);
                      }}
                      style={{ height: "4rem" }}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <label className="form-label fw-bold">
                    Tracking Details<span className="fw-bold text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control "
                    placeholder="Enter courier details"
                    value={trackingDetails}
                    onChange={(e) => {
                      setTrackingDetails(e.target.value);
                    }}
                    required
                  ></textarea>
                </div>
                <div className="col-lg-12 mt-2">
                  <div className="input-blocks">
                    <label>Products to Add</label>
                    <Select
                      className="select"
                      id="storeSelect"
                      onChange={handleProductChange}
                      options={productsData.map((prod) => ({
                        value: prod.Id,
                        label: prod.ProductName,
                      }))}
                      placeholder="Choose products"
                      styles={customStyles}
                    />
                  </div>
                </div>
                <p className="text-danger fw-bold">{transferProductErro}</p>
              </div>
              <div className="table-responsive">
                <table className="table datanew">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>From Stock</th>
                      <th>To Stock</th>
                      <th>Quantity</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transferproductsData.length !== 0 ? (
                      transferproductsData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.Name}</td>
                          <td>{item.SourceStock}</td>
                          <td>{item.DestinationStock}</td>
                          <td>
                            <input
                              className="form-control"
                              type="text"
                              style={{ height: "2rem", width: "6rem" }}
                              placeholder="Enter quantity"
                              value={item.Quantity}
                              onChange={(e) =>
                                handleQuantityChange(index, e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn border text-danger"
                              onClick={() => handleDelete(index)}
                            >
                              <i className="feather-trash-2 fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No Data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-warning me-3"
                  onClick={() => handleSubmit("DRAFT")}
                >
                  {btnSubLoading ? "Submitting..." : "Draft"}
                </button>
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => handleSubmit("TRANSFERED")}
                >
                  {btnSubLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Stock */}

      {/* View Stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewStockTrnsf"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "45%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            View Transfer (ST-{transferObj?.AutoGenTransactionNo})
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <div id="pdf-content">
            <div className="d-flex">
              <h4>{transferObj.TransferOrder}</h4>
              <h4
                className={`ms-auto ${
                  transferObj.Status === 1
                    ? "text-warning"
                    : transferObj.Status === 2
                    ? "text-success"
                    : transferObj.Status === 3
                    ? "text-danger"
                    : ""
                }`}
              >
                {transferObj.Status === 1
                  ? "In Transit"
                  : transferObj.Status === 2
                  ? "Received"
                  : transferObj.Status === 3
                  ? "Canceled"
                  : ""}
              </h4>
            </div>
            <div className="d-flex my-2 table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">Date</th>
                    <th className="">Source</th>
                    <th className="">Destination</th>
                    <th className="">Transfer by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold">
                      {formatDate(transferObj?.TransferDate)}
                    </td>
                    <td className="fw-bold">{transferObj?.FromStore}</td>
                    <td className="fw-bold">{transferObj?.ToStore}</td>
                    <td className="fw-bold">{transferObj?.TransferBy}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="my-3">
              <label className="form-label fw-bold">Notes:</label>
              <textarea
                className="form-control "
                readOnly
                value={transferObj?.Notes}
              ></textarea>
            </div>
            <div className="row">
              <div className="">
                <label className="form-label fw-bold">Tracking Details:</label>
                <textarea
                  className="form-control "
                  value={transferObj?.TrackingDetails}
                  readOnly
                ></textarea>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">#</th>
                    <th className="">Item</th>
                    <th className="">Req Qty</th>
                    <th className="">Transfer Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{ position: "relative", height: "10px" }}
                      >
                        <div className="loader m-auto"></div>
                      </td>
                    </tr>
                  ) : (
                    transferProductsViewData?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="fw-bold">{item.ProductName}</td>
                        <td className="fw-bold">{item.ReqQuantity}</td>
                        <td className="fw-bold">{item.TransferQty}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Receive stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightRecStockTrnsf"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "45%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel">
            Receive Stock (ST-{transferObj?.AutoGenTransactionNo})
          </h4>
          
          <div className="d-flex ms-auto">
            {/* <button
              className="btn btn-primary me-3 d-flex"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightUploadFiles"
              aria-controls="offcanvasRightUploadFiles"
              onClick={() => showUploadFilesModal(transferObj)}
            >
              Upload<i className="fa-solid fa-cloud-arrow-up ms-2"></i>
            </button> */}

            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div id="pdf-content">
            <div className="d-flex">
              <h4>{transferObj.TransferOrder}</h4>
              <h4
                className={`ms-auto ${
                  transferObj.Status === 1
                    ? "text-warning"
                    : transferObj.Status === 2
                    ? "text-success"
                    : transferObj.Status === 3
                    ? "text-danger"
                    : ""
                }`}
              >
                {transferObj.Status === 1
                  ? "In Transit"
                  : transferObj.Status === 2
                  ? "Received"
                  : transferObj.Status === 3
                  ? "Canceled"
                  : ""}
              </h4>
            </div>
            <div className="col-6">
              <label>Received Date</label>
              <input
                type="date"
                className="form-control"
                value={selectedReceivedDate}
                onChange={(e) => setSelectedReceivedDate(e.target.value)}
              />
            </div>
            <div className="d-flex my-2 table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">Date</th>
                    <th className="">Source</th>
                    <th className="">Destination</th>
                    <th className="">Transfer by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold">
                      {formatDate(transferObj?.TransferDate)}
                    </td>
                    <td className="fw-bold">{transferObj?.FromStore}</td>
                    <td className="fw-bold">{transferObj?.ToStore}</td>
                    <td className="fw-bold">{transferObj?.TransferBy}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="my-3">
              <label className="form-label fw-bold">Notes:</label>
              <textarea
                className="form-control "
                readOnly
                value={transferObj?.Notes}
              ></textarea>
            </div>
            <div className="row">
              <div className="">
                <label className="form-label fw-bold">Tracking Details:</label>
                <textarea
                  className="form-control "
                  value={transferObj?.TrackingDetails}
                  readOnly
                ></textarea>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">#</th>
                    <th className="">Item</th>
                    <th className="">Req Qty</th>
                    <th className="">Transfer Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{ position: "relative", height: "10px" }}
                      >
                        <div className="loader m-auto"></div>
                      </td>
                    </tr>
                  ) : (
                    transferProductsViewData?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="fw-bold">{item.ProductName}</td>
                        <td className="fw-bold">{item.ReqQuantity}</td>
                        <td className="fw-bold">{item.TransferQty}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <button 
              className="btn btn-primary d-flex ms-auto mt-3"
              onClick={handleReceiveBtnClick}
            >
              {btnSubLoading ? 'Submitting...' : 'Received'}
            </button>
          </div>
        </div>
      </div>
      {/* Receive stock */}

      {/* Edit Stock Transfer */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditStockTrnsf"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            Edit Transfer (ST-{transferObj?.AutoGenTransactionNo})
          </h4>
          {/* <button
            className={`btn btn-success rounded me-3 ${
              transferObj.Status === 2 ? "d-none" : "d-block"
            }`}
            title="Receive Stock"
            type="button"
            onClick={handleReceiveBtnClick}
          >
            <i className="fa-solid fa-download fs-5"></i>
          </button> */}
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
      <div className="offcanvas-body">
        <div id="pdf-content">
        <div className="d-flex">
              <h4>{transferObj.TransferOrder}</h4>
              <h4
                className={`ms-auto ${
                  transferObj.Status === 1
                    ? "text-warning"
                    : transferObj.Status === 2
                    ? "text-success"
                    : transferObj.Status === 3
                    ? "text-danger"
                    : ""
                }`}
              >
                {transferObj.Status === 1
                  ? "In Transit"
                  : transferObj.Status === 2
                  ? "Received"
                  : transferObj.Status === 3
                  ? "Canceled"
                  : ""}
              </h4>
            </div>
            <div className="d-flex my-2 table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th className="">Date</th>
                    <th className="">Source</th>
                    <th className="">Destination</th>
                    <th className="">Transfer by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold">
                      {formatDate(transferObj?.TransferDate)}
                    </td>
                    <td className="fw-bold">{transferObj?.FromStore}</td>
                    <td className="fw-bold">{transferObj?.ToStore}</td>
                    <td className="fw-bold">{transferObj?.TransferBy}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="my-3">
              <label className="form-label fw-bold">Notes:</label>
              <textarea
                className="form-control "
                readOnly
                value={transferObj?.Notes}
              ></textarea>
            </div>
            <div className="row">
              <div className="">
                <label className="form-label fw-bold">Tracking Details:</label>
                <textarea
                  className="form-control "
                  value={transferObj?.TrackingDetails}
                  readOnly
                ></textarea>
              </div>
            </div>

          {/* Editable Transfer Date */}
          <div className="my-3 col-lg-4">
            <label className="form-label fw-bold">Transfer Date:</label>
            <input
              type="date"
              className="form-control"
              value={editableTransferDate}
              onChange={(e) => setEditableTransferDate(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="">#</th>
                  <th className="">Item</th>
                  <th className="">Req Qty</th>
                  <th className="">Transfer Qty</th> {/* Editable Quantity */}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ position: "relative", height: "10px" }}
                    >
                      <div className="loader m-auto"></div>
                    </td>
                  </tr>
                ) : (
                  editableTransferProducts?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="fw-bold">{item.ProductName}</td>
                      <td className="fw-bold">{item.ReqQuantity}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={item.TransferQty}
                          onChange={(e) => handleTransferQtyChange(e, index)}
                          onWheel={(e) => e.target.blur(e)}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <button 
            className="btn btn-primary d-flex ms-auto mt-3"
            onClick={() => handleEditSubmit("TRANSFERED")}
          >Submit</button>
        </div>
      </div>
      </div>

      {/* <UploadFiles number={uploadStockObj?.TransferId} type={"Stock"} /> */}

    </div>
  );
};

StockTransferModal.propTypes = {
  transferObj: PropTypes.object.isRequired,
};

export default StockTransferModal;
